<template>
  <div class="FunctinalityDetailsTab">
    <div v-if="list.length > 0">
      <functinality-details-list-web :list="list" class="hidden-sm-and-down" />
      <functinality-details-list-mob :list="list" class="hidden-md-and-up" />
    </div>
    <div v-else>
      <EmptyList />
    </div>
  </div>
</template>

<script>
import FunctinalityDetailsListWeb from "./FunctinalityDetailsListWeb.vue";
import FunctinalityDetailsListMob from "./FunctinalityDetailsListMob.vue";
export default {
  components: {
    FunctinalityDetailsListWeb,
    FunctinalityDetailsListMob,
  },
  props: {
    args: Object,
  },
  mounted() {
    this.GetPeriodBeginAndEndDate();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    GetPeriodBeginAndEndDate() {
      const params = new URLSearchParams();
      params.append("periodNumber", this.args.period);
      params.append("year", this.args.year);
      if (this.args.perno) {
        params.append("employeeId", this.args.perno);
      }

      this.$store
        .dispatch("GetPeriodBeginAndEndDate", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              let data = result.data[0];
              this.GetPersonDayWorks(data.BeginDate, data.EndDate);
            }
          }
        });
    },
    GetPersonDayWorks(BeginDate, EndDate) {
      const params = new URLSearchParams();
      params.append("beginDate", BeginDate);
      params.append("endDate", EndDate);
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }

      this.$store
        .dispatch("GetPersonDayWorks", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.list = result.data.Table;
          } else{
            this.$emit('onErrorFetchData')
          }
        });
    },
  },
};
</script>

<style>
</style>